import type { ReactNode } from "react";
import {
  BORDER_RADIUS,
  COLORS,
  SPACING,
  TYPOGRAPHY,
} from "../../constants/theme";

interface NavCardProps {
  label: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
}

export function NavCard({ label, description, icon, onClick }: NavCardProps) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: SPACING.md,
        padding: SPACING.lg,
        backgroundColor: COLORS.background.primary,
        border: `1px solid ${COLORS.border.light}`,
        borderRadius: BORDER_RADIUS.md,
        cursor: "pointer",
        textAlign: "left",
        flex: "1 1 160px",
        transition: "border-color 0.15s, box-shadow 0.15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = `0 0 0 1px ${COLORS.primary.light}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span style={{ color: COLORS.primary.main, flexShrink: 0 }}>{icon}</span>
      <span>
        <div
          style={{
            fontSize: TYPOGRAPHY.fontSize.sm,
            fontWeight: TYPOGRAPHY.fontWeight.semibold,
            color: COLORS.text.primary,
          }}
        >
          {label}
        </div>
        <div
          style={{
            fontSize: TYPOGRAPHY.fontSize.xs,
            color: COLORS.text.secondary,
            marginTop: "2px",
          }}
        >
          {description}
        </div>
      </span>
    </button>
  );
}
